import {Column, Entity, JoinColumn, ManyToOne, PrimaryColumn} from "typeorm";
import {Navigation} from "./Navigation";
import {Exclude} from "class-transformer";

@Entity()
export class Point {
  @Column({type: "float", nullable: true, name: "a"})
  a: number | null;

  @Column({type: "int", nullable: true, name: "c"})
  c: number | null;

  @Column({type: "float", nullable: true, name: "e"})
  e: number | null;

  @Column({type: "int", nullable: true, name: "h"})
  h: number | null;

  @Column({type: "float", nullable: true, name: "l"})
  l: number | null;

  @PrimaryColumn({type: "varchar", name: "m"})
  m: string;

  @Column({type: "float", nullable: true, name: "n"})
  n: number | null;

  @Column({type: "int", nullable: true, name: "p"})
  p: number | null;

  @Column({type: "float", nullable: true, name: "r"})
  r: number | null;

  @Column({type: "float", nullable: true, name: "s"})
  s: number | null;

  @Column({type: "bigint", nullable: true, name: "t"})
  t: string | null;

  @PrimaryColumn({type: "varchar", name: "nID"})
  nID: string;

  @Exclude()
  @ManyToOne(() => Navigation, (navigation) => navigation.points, {onDelete: "CASCADE"})
  @JoinColumn({name: "nID", referencedColumnName: "ID"})
  navigation: Navigation;
}
